/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Cell } from "react-table";
import { Button, FlexContainer } from "@nordcloud/gnui";
import { BusinessContextsForm } from "~/views/businessContexts/BusinessContextsForm";

type FormValues = NonNullable<
  React.ComponentProps<typeof BusinessContextsForm>["initialValues"]
>;

type Props = {
  onEditHandler: (item: FormValues) => void;
  setIsModalConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteData: React.Dispatch<
    React.SetStateAction<{
      id: string;
      name: string;
    }>
  >;
};

export const OrganizationUnitTypesListColumns = ({
  onEditHandler,
  setIsModalConfirmOpen,
  setDeleteData,
}: Props) => [
  {
    Header: "Unit Types",
    accessor: "name",
    disableSortBy: true,
  },
  {
    Header: "Description",
    accessor: "description",
    disableSortBy: true,
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
    width: "4.5rem",
    Cell: ({ row }: Cell<FormValues>) => {
      return (
        <FlexContainer>
          <Button
            mr="0.5rem"
            size="md"
            severity="low"
            icon="edit"
            onClick={() => {
              onEditHandler(row?.original);
            }}
          />
          <Button
            size="md"
            severity="low"
            icon="trash"
            onClick={() => {
              setIsModalConfirmOpen(true);
              setDeleteData({
                id: row?.original?.id,
                name: row?.original?.name,
              });
            }}
          />
        </FlexContainer>
      );
    },
  },
];
